"use client";
import { isGitHubUrl as n } from "./utils/misc.js";
const o = (t, p) => {
  const s = [];
  t.type === "documentation" && t.contentType === "book" ? s.push("Publications") : t.type === "documentation" && t.contentType === "pdf" && s.push("PDFs"), (t.type === "github_issue" || n(t.url)) && s.push("GitHub"), t.type === "discourse" && s.push("Forums"), t.type === "discord" && s.push("Discord"), t.type === "slack_message" && s.push("Slack"), t.type === "stackoverflow" && s.push("StackOverflow");
  const e = [], a = p?.tabs?.map((i) => typeof i == "string" ? i : i[0]);
  for (const i of s)
    a?.includes(i) && (i === t.breadcrumbs?.[0] ? e.push([i, { breadcrumbs: t.breadcrumbs?.slice(1) }]) : e.push(i));
  return e;
};
export {
  o as getTabs
};
